import Constants from 'constants';
import { uniqBy, takeRight } from 'lodash';

const _defaultState = [],

    hotelRecentSearch = (state = _defaultState, action) => {
        try {
            const { type, payload } = action;
            switch (type) {
                case Constants.actions.RECENT_SEARCH.UPDATE_LIST: {
                    let oldState = state;
                    if (action.payload != "") {
                        oldState.push({ ...payload });
                        oldState = uniqBy(oldState, "url");
                        oldState = takeRight(oldState, 10)
                    }
                    return oldState;
                }
                default:
                    return state;
            }
        } catch (error) {
            return _defaultState;
        }
    };

export default hotelRecentSearch;
